import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientService } from 'src/app/service/client/client.service';
import Swal from 'sweetalert2';
import { Validations } from '../../validations';

@Component({
  selector: 'app-client-active-account',
  templateUrl: './client-active-account.component.html',
  styleUrls: ['./client-active-account.component.css']
})
export class ClientActiveAccountComponent implements OnInit {

  token: string = "";
  id: number;
  activeForm: FormGroup;
  loading: boolean = false;

  constructor(
    private service: ClientService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.route.params.subscribe(params => {
      this.token = params['token'];
    });
  }

  ngOnInit(): void {
    this.createForm();

  }
  createForm() {
    this.activeForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(8), Validations.validatePassword]],
      confirmationPassword: ['', [Validators.required, Validations.equalsPassword]]
    });
  }
  onSubmit() {

    const password = this.activeForm.controls.password.value;
    const confirmationPassword = this.activeForm.controls.confirmationPassword.value;

    if (password !== confirmationPassword) {
      this.activeForm.controls.confirmationPassword.setErrors({ differentPasswords: true })
    }
    if (this.activeForm.valid) {

      this.loading = true;

      const value = {
        token: this.token,
        password: this.activeForm.controls.password.value
      }
      this.service.activeAccount(value).subscribe(data => {
        this.loading = false;
        Swal.fire('Sucesso', 'Cliente Ativado com Sucesso!!', 'success');
        this.router.navigate(['login']);
      },
        error => {
          this.loading = false;
          this.setErrors(error.error.errors);
          Swal.fire('Erro ao salvar', 'Erro ao Ativar Cliente!', 'error');
        });
    }
  }
  setErrors(errors) {
    errors.forEach(erro => {
      if (erro.fieldName === 'password') {
        this.activeForm.controls.password.setErrors({ invalid: erro.message });
      }
      if (erro.fieldName === 'token') {
        this.activeForm.controls.password.setErrors({ token: erro.message });
      }

    });

  }
}
